package com.qrkontaq.ui.sections.header

import androidx.compose.runtime.Composable
import com.qrkontaq.ui.sections.header.components.Logo
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem

@Composable
fun NavHeader(modifier: Modifier = Modifier) {
    Row(
        NavHeaderStyle.toModifier().then(modifier),
        verticalAlignment = Alignment.CenterVertically
    ) {


        Spacer()

        Row(
            Modifier
                .gap(1.cssRem)
                .displayUntil(Breakpoint.MD),
            verticalAlignment = Alignment.CenterVertically
        ) {
            NavHeaderMobile()
        }

        Row(
            Modifier
                .gap(2.cssRem)
                .displayIfAtLeast(Breakpoint.MD),
            verticalAlignment = Alignment.CenterVertically
        ) {
            NavHeaderDesktop()
        }

        Spacer()
    }
}
